export default ($container) => {
    $('.js-search-toggle', $container).click(function(e) {
        e.preventDefault();
        const $header = $('.header__search');
        $header.fadeIn('fast');
        $(':input[name="query"]:visible', $header).trigger('focus');
    });

    $('.js-search-close', $container).click(function(e) {
        e.preventDefault();
        $('.header__search').fadeOut('fast');
    });

    let $back = $('.js-menu-back', $container);

    $('.js-mobile-menu li.has-children > a', $container).each(function(i) {
        $(this).attr('href', `#menu0${i}`);
        $(this).next('ul').attr('id', `menu0${i}`);
        let $sublist = $(this).next('ul');

        $('.header__menu-holder').append($sublist);

        $(this).click(function(e) {
            e.preventDefault();
            let $href = $(this).attr('href');

            $($href).addClass('is-active');
            $back.addClass('is-active');
            let $title = $(this).text();

            $back.text($title);
            $back.attr('href', $href);
        });
    });

    $back.click(function(e) {
        e.preventDefault();
        $(this).removeClass('is-active');
        let $href = $(this).attr('href');

        $($href).removeClass('is-active');
    });

    $('.js-menu-open', $container).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.header__menu, body, html ').addClass('is-active');
    });

    $('.js-menu-close', $container).click(function(e) {
        e.preventDefault();
        $('.header__menu, body, html').removeClass('is-active');
    });

    if ($container.is('body')) {
        $('body, html').click(function() {
            $('.header__menu, body, html').removeClass('is-active');
        });
    }

    $('.header__menu-tools, .header__menu-holder', $container).click(function(e) {
        e.stopPropagation();
    });
};
